import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getMinimumFeeSettings() {
  return {
    types: [
      ACTION_TYPES.WEBCHAT_MINIMUM_FEE_GET_REQUESTED,
      ACTION_TYPES.WEBCHAT_MINIMUM_FEE_GET_SUCCEED,
      ACTION_TYPES.WEBCHAT_MINIMUM_FEE_GET_FAILED,
    ],
    promise: client => client.get('configs/fee'),
    options: {
      clientName: API_CONSULT,
    },
  };
}
